mat-button-toggle-group{display:inline-flex;align-items:center;height:28px;border-radius:0}
/*# sourceMappingURL=side-view-toggle-button.component.css.map */
